import { WORLD_CUP_2026_GROUP_TEAMS } from '@/lib/world_cup_2026/common-data';

type TranslateFn = (key: string) => string;

const TEAM_TRANSLATION_ENTRIES = Object.values(WORLD_CUP_2026_GROUP_TEAMS)
  .flatMap((teams) =>
    teams.flatMap((team) =>
      [team.enName, ...team.aliases].filter(isFullTeamName).map((alias) => ({
        alias,
        translationKey: team.enName,
      })),
    ),
  )
  .sort((left, right) => right.alias.length - left.alias.length);

export function translateWorldCupTeamName(name: string | null | undefined, t: TranslateFn) {
  if (!name) return '';

  const exactEntry = TEAM_TRANSLATION_ENTRIES.find(
    (entry) => entry.alias.toLowerCase() === name.toLowerCase(),
  );

  return exactEntry ? t(exactEntry.translationKey) : t(name);
}

export function translateWorldCupTeamText(text: string | null | undefined, t: TranslateFn) {
  if (!text) return '';

  return TEAM_TRANSLATION_ENTRIES.reduce((result, entry) => {
    const pattern = new RegExp(
      `(^|[^\\p{L}\\p{N}])(${escapeRegExp(entry.alias)})(?=$|[^\\p{L}\\p{N}])`,
      'giu',
    );

    return result.replace(pattern, (_match, prefix) => {
      return `${prefix}${t(entry.translationKey)}`;
    });
  }, text);
}

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function isFullTeamName(value: string) {
  return value.trim().length > 3;
}
